import axios from "axios";
export const loadConfig = async () => {
  try {
    const response = await axios.get("/config.json");
    if (response.status < 400) {
      console.log(typeof response.data);
      return response.data;
    }
    return null;
  } catch (err) {
    console.error(err);
    return null;
  }
};
